import { IntervalInput } from '@/generated/graphql';
import { DateTime, Duration } from 'luxon';
import { AllocationPhaseUpdate } from '../Timeline.types';

export function calculatePhaseUpdate(
    phases: AllocationPhaseUpdate[],
    allocation: { startDate: DateTime; endDate: DateTime },
): { startDateTime: DateTime; endDateTime: DateTime } {
    let startDayDelta = 0;
    let endDayDelta = 0;
    let durationInDays = 0;

    for (const phase of phases) {
        durationInDays = durationInDays + phase.cellSpanBefore + phase.cellSpan + phase.cellSpanAfter;

        if (phase.position === 'Before-Main' || phase.position === 'Main') {
            startDayDelta = startDayDelta + phase.cellSpanBefore;
        }

        if (phase.position === 'Main' || phase.position === 'After-Main') {
            endDayDelta = endDayDelta + phase.cellSpanAfter;
        }
    }

    return {
        startDateTime: allocation.startDate.minus({ days: startDayDelta }),
        endDateTime: allocation.endDate.plus({ days: endDayDelta }),
    };
}

export function getDurationInDays(interval: IntervalInput) {
    const durationInDays = Duration.fromObject({
        seconds: interval.seconds ?? undefined,
        minutes: interval.minutes ?? undefined,
        hours: interval.hours ?? undefined,
        days: interval.days ?? undefined,
        months: interval.months ?? undefined,
        years: interval.years ?? undefined,
    }).as('days');

    return durationInDays;
}
